<template>
  <div class="hl-descriptions">
    <div class="hl-descriptions-title" v-if="title">{{ title }}</div>
    <div class="hl-descriptions-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <div class="hl-descriptions-content">
      <el-row :gutter="gutter">
        <slot></slot>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    gutter: {
      type: Number,
      default: 16
    }
  }
}
</script>

<style lang="scss">
.hl-descriptions {
  .hl-descriptions-title {
    font-size: 24px;
    color: #333333;
    font-weight: 600;
    margin-bottom: 12px;
  }
}
</style>
